import type { Components } from '@mui/material'

export const MuiTextField: Components['MuiTextField'] = {
  defaultProps: { variant: 'outlined', margin: 'dense', fullWidth: true, size: 'small' },
}
